import WebApi from "@/views/loyalty/shared/modules/web_api"

export class JustpayPaymentSystemEndpointService {
    constructor () {
        this.url = `${process.env.VUE_APP_JUSTPAY_URL}api/paymentsystem/`
        this.webApi = new WebApi()
    }

    async createPayment (createPaymentRequest) {
        const response = await this.webApi.post(`${this.url}CreateBankPayment`, createPaymentRequest)
        if (response) {
            if (!response.status_code) {
                if (!response.error) {
                    return response
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${response.status_code}`)
            }
        }
        return null
    }

    async getCheque (paymentId) {
        const ret = await this.webApi.get(`${this.url}GetCheque/${paymentId}`)
        // console.log('getCheque ret', ret)
        if (ret) {
            if (!ret.status_code) {
                return ret
            } else {
                return null
            }
        } else {
            console.error(`Ошибка с кодом: ${ret.status_code}`)
        }
        return null
    }

    async getEntities (pointId) {
        const response = await this.webApi.get(`${this.url}${pointId}`)
        return response
    }

    async getQrcode (pointId) {
        const ret = await this.webApi.get(`${this.url}qrcode/${pointId}`)
        console.log('getQrcode ret', ret)
        if (ret) {
            if (!ret.status_code) {
                return ret.value
            } else {
                return null
            }
        } else {
            console.error(`Ошибка с кодом: ${ret.status_code}`)
        }
        return null
    }

    async getPaymentByIdempotency (idempotency) {
        return this.webApi.get(`${this.url}GetPaymentByIdempotency/${idempotency}`)
    }
}
